import { render } from "./ResetPassword.vue?vue&type=template&id=04e82461&scoped=true&ts=true"
import script from "./ResetPassword.ts?vue&type=script&lang=ts"
export * from "./ResetPassword.ts?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=04e82461&scoped=true&lang=scss"

import exportComponent from "D:\\OdocsPortal\\odocsportal-frontend-master\\odocsportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e82461"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn});
